import api from "./api";

// Capa de servicios API del dominio "chat interno" (chats de equipo) (FSD / capa API transversal).
// Wrappers de transporte finos: la construcción de payloads/params vive en el
// componente; aquí solo se centraliza el endpoint (un único lugar que tocar si cambia).

export const listChats = (params) => api.get("/chats", { params });
export const listChatMessages = (chatId, pageNumber) =>
  api.get(`/chats/${chatId}/messages`, { params: { pageNumber } });
export const createChat = (payload) => api.post("/chats", payload);
export const updateChat = (chatId, payload) => api.put(`/chats/${chatId}`, payload);
export const deleteChat = (chatId) => api.delete(`/chats/${chatId}`);
export const markChatRead = (chatId, payload) =>
  api.post(`/chats/${chatId}/read`, payload);
export const sendChatMessage = (chatId, payload) =>
  api.post(`/chats/${chatId}/messages`, payload);
